import React from 'react';
import * as asyncLoad from '../util/asyncLoad';
import { fnaFiles } from '../constants/fileConfig';
import Loading from './Loading';

export default class FnaInvoiceIdentify extends React.Component{
    constructor(){
        super();
        this.state = {
            hasLoad: false
        };
    }
	
    componentDidMount(){
        const init = () =>{
            this.setState({hasLoad:true});
        }
        asyncLoad.asyncLoadModule('fna', fnaFiles, init);
    }
    render(){
        const { hasLoad } = this.state;
        const {symbol,commonParam} = this.props;
        if(hasLoad){
            const { FnaInvoiceIdentifyPage } = window.weaFna.com;
            return (
                <FnaInvoiceIdentifyPage ecId={`${this && this.props && this.props.ecId || ''}_FnaInvoiceIdentifyPage@libdru`} {...this.props} commonParam={commonParam} symbol={symbol} />
            )
        }else{
            return (<Loading ecId={`${this && this.props && this.props.ecId || ''}_Loading@qvuoea`} />);
        }
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/asyncComps/FnaInvoiceIdentify.js